import { colors } from '@/theme/colors';

interface ArrowWithTailLeftProps {
  className?: string;
  fill?: string;
}

export default function ArrowWithTailLeft({
  className = 'h-[24px] w-[25px]',
  fill = colors.neutral100,
}: ArrowWithTailLeftProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 24"
      fill="none"
      className={className ?? 'h-[24px] w-[25px]'}
    >
      <path
        d="M2.5 12C2.5 11.6899 2.63757 11.3798 2.88095 11.1628L9.83333 4.36176C10.1085 4.10336 10.3942 4 10.6799 4C11.3466 4 11.8228 4.45478 11.8228 5.07494C11.8228 5.39535 11.6958 5.67442 11.4841 5.88114L9.11376 8.22739L5.99206 11.0181L8.45767 10.8734H21.3254C22.0132 10.8734 22.5 11.3282 22.5 12C22.5 12.6615 22.0132 13.1266 21.3254 13.1266H8.45767L5.98148 12.9819L9.11376 15.7726L11.4841 18.1189C11.6958 18.3152 11.8228 18.5943 11.8228 18.9147C11.8228 19.5349 11.3466 20 10.6799 20C10.3942 20 10.1085 19.8863 9.8545 19.6486L2.88095 12.8372C2.63757 12.6098 2.5 12.3101 2.5 12Z"
        fill={fill}
      />
    </svg>
  );
}
